import { DesktopOutlined } from "@ant-design/icons";
import {
  AdminForgotPassword,
  AdminLogin,
  AdminOtpVerification,
  AdminResetPassword,
} from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for admin authentication-related pages.
 * @returns {Array} An array containing route objects for admin authentication pages.
 */
export default function route() {
   // Define a reusable icon for the routes
   const routeIcon = <DesktopOutlined />;
  return [
    // Admin Login Route
    {
      path: adminRouteMap.LOGIN.path,
      name: "Admin Login",
      key: adminRouteMap.LOGIN.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminLogin />,
    },
    // Admin Forgot Password Route
    {
      path: adminRouteMap.FORGOT_PASSWORD.path,
      name: "Admin Forgot Password",
      key: adminRouteMap.FORGOT_PASSWORD.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminForgotPassword />,
    },
    // Admin Reset Password Route
    {
      path: adminRouteMap.RESET_PASSWORD.path,
      name: "Admin Reset Password",
      key: adminRouteMap.RESET_PASSWORD.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminResetPassword />,
    },
    // Admin OTP Verification Route
    {
      path: adminRouteMap.OTP_VERIFICATION.path,
      name: "Admin OTP Verification",
      key: adminRouteMap.OTP_VERIFICATION.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <AdminOtpVerification />,
    },
  ];
}
